import ProjectModel from "./ProjectModel";

// NOTE: descriptions are placeholder copy.
export default function ProjectsSection() {
  return (
    <>
      <ProjectModel
        labelOffset={[0, 4, 0]}
        rotation={[0, Math.PI / 4, 0]}
        position={[10, 2, 20]}
        modelScale={0.15}
        name="OVA.DESIGN"
        src="https://ova.design/"
        description="A design studio crafting brand identities and digital experiences. Explore the portfolio and creative work behind OVA."
        modelPath="./models/project/OvaHeroLogoAnimation.glb"
        animationSpeed={0.3}
        pingPongClips={["VertexAnimation"]}
      />
      <ProjectModel
        labelOffset={[0, 4, 0]}
        rotation={[0, Math.PI / 4, 0]}
        position={[20, 2, 10]}
        scale={1}
        name="PARALLEL AI"
        src="https://parallelai.app/"
        description="An AI application for running multiple model conversations side by side. Compare outputs and workflows in parallel."
        modelPath="./models/project/parallel-ai-slice-stack.glb"
      />
      <ProjectModel
        labelOffset={[0, 4, 0]}
        rotation={[0, Math.PI / 4, 0]}
        position={[25, 2, 25]}
        modelScale={0.4}
        name="WHISPERO"
        src="https://github.com/parkercai/WhisperO"
        description="An open-source speech-to-text tool built on Whisper. Fast local transcription with a lightweight interface."
        modelPath="./models/project/whispero_meshopt_micro.glb"
        sway={{ pitch: 0.15, yaw: 0.15, speed: 1.2 }}
      />
      <ProjectModel
        labelOffset={[0, 4, 0]}
        rotation={[0, Math.PI / 4, 0]}
        position={[35, 2, 15]}
        name="OPALITE"
        src="https://github.com/ParkerCai/Opalite"
        description="An open-source project exploring generative visuals and materials. Check out the source and experiments on GitHub."
        modelPath="./models/project/opalite-stone-morph.glb"
        modelScale={[1.3, 1.6, 1.4]}
        sway={{ yaw: 0.4, speed: 0.8 }}
      />
      <ProjectModel
        labelOffset={[0, 4, 0]}
        rotation={[0, Math.PI / 4, 0]}
        position={[15, 2, 35]}
        name="CRIA DESIGN"
        src="https://cria.design/"
        description="Agentic Design software"
        modelPath="./models/project/cria_walk_meshopt.glb"
        modelScale={5.5}
        modelOffset={[0, -2, 0]}
        modelRotation={[0, -Math.PI / 4, 0]}
      />
    </>
  );
}
